const getDeviceType = () => {
    if (typeof window === 'undefined') return 'unknown';
    const ua = navigator.userAgent || '';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile';
    if (/Tablet|iPad/i.test(ua)) return 'tablet';
    return 'desktop';
};

const getPagePath = () => {
    if (typeof window === 'undefined') return '';
    return window.location.pathname + window.location.search;
};

const RESERVED_GA4_PARAMS = new Set([
    'source',
    'medium',
    'campaign',
    'term',
    'content',
]);

export function sanitizeGAParams(params) {
    if (!params) return {};
    const out = {};
    for (const key of Object.keys(params)) {
        if (RESERVED_GA4_PARAMS.has(key)) {
            out[`cta_${key}`] = params[key];
        } else {
            out[key] = params[key];
        }
    }
    return out;
}

const CLARITY_FORWARD_EVENTS = new Set([
    'add_ad_success',
    'add_ad_error',
    'contact_seller',
    'phone_contact_attempt_sell',
    'phone_contact_attempt_rent',
    'phone_tap',
    'form_validation_error',
    'page_not_found',
    'social_click',
]);

export function trackEvent(eventName, params = {}) {
    if (typeof window === 'undefined') return;

    const enriched = sanitizeGAParams({
        page_path: getPagePath(),
        device: getDeviceType(),
        ...params,
    });

    if (typeof window.gtag === 'function') {
        try {
            window.gtag('event', eventName, enriched);
        } catch {}
    }

    if (
        CLARITY_FORWARD_EVENTS.has(eventName) &&
        typeof window.clarity === 'function'
    ) {
        try {
            window.clarity('event', eventName);
            if (params.advert_id) {
                window.clarity('set', 'advert_id', String(params.advert_id));
            }
            if (params.section) {
                window.clarity('set', 'section', String(params.section));
            }
        } catch {}
    }
}

export function setClarityTag(name, value) {
    if (typeof window === 'undefined') return;
    if (typeof window.clarity !== 'function') return;
    if (!name || value === undefined || value === null) return;
    try {
        window.clarity('set', String(name), String(value));
    } catch {}
}

export function trackSearchResults(values, section) {
    const v = values || {};
    const activeFilters = Object.entries(v)
        .filter(([k, val]) => {
            if (k === 'typeVehicle' || k === 'type' || k === 'status') {
                return false;
            }
            if (val === null || val === undefined || val === '') return false;
            if (Array.isArray(val) && val.length === 0) return false;
            return true;
        })
        .map(([k]) => k);

    trackEvent('view_search_results', {
        event_category: 'search',
        search_term: [v.mark, v.model, v.city, v.partsName, v.typeService]
            .filter(Boolean)
            .join(' '),
        section: section || 'unknown',
        mark: v.mark || '',
        model: v.model || '',
        city: Array.isArray(v.city) ? v.city.join(',') : v.city || '',
        price_from: v.priceFrom || '',
        price_to: v.priceTo || '',
        years_from: v.yearsFrom || '',
        years_to: v.yearsTo || '',
        filters_used: activeFilters.join(','),
        filter_count: activeFilters.length,
    });
}
